export default "__VITE_ASSET__rhcw357t__"